import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CookieConsentBanner: React.FC = () => {
  const { t } = useTranslation();

  const handleAccept = () => {
    // Enable Google Analytics when user accepts
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
    console.log('Cookies accepted - Analytics enabled');
  };

  const handleDecline = () => {
    // Disable Google Analytics when user declines
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }
    console.log('Cookies declined - Analytics disabled');
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('cookieConsent.accept')}
      declineButtonText={t('cookieConsent.decline')}
      enableDeclineButton
      onAccept={handleAccept}
      onDecline={handleDecline}
      cookieName="mwqq_cookie_consent"
      style={{
        background: 'rgba(31, 41, 55, 0.98)',
        padding: '20px',
        alignItems: 'center',
      }}
      buttonStyle={{
        background: '#3b82f6',
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: '600',
        padding: '10px 24px',
        borderRadius: '6px',
        border: 'none',
        cursor: 'pointer',
      }}
      declineButtonStyle={{
        background: 'transparent',
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: '600',
        padding: '10px 24px',
        borderRadius: '6px',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
      }}
      expires={365}
      overlay={false}
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-white text-sm sm:text-base mb-2">
            {t('cookieConsent.message')}
          </p>
          <Link
            to="/cookies.html"
            className="text-blue-300 hover:text-blue-200 text-sm underline"
          >
            {t('cookieConsent.learnMore')}
          </Link>
        </div>
      </div>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
